import {
  Button,
  Container,
  InputWrapper,
  Section,
  SectionText,
  SectionTitle,
} from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import type { MtApplicationCheckoutFailedPageProps } from './types';

export * from './types';

export const MtApplicationCheckoutFailedPage: FC<MtApplicationCheckoutFailedPageProps> = (
  props,
) => {
  const { applicationsLink } = props;

  const { translate } = useTranslation();
  const { translate: translateResource } = useTranslation({
    keyPrefix: 'mt.buyer.applications.paymentFailed',
  });

  return (
    <Container>
      <Section centerChildren>
        <SectionTitle color="red">{translateResource('title')}</SectionTitle>
        <InputWrapper>
          <SectionText>{translateResource('text')}</SectionText>
        </InputWrapper>
        <InputWrapper>
          <Button link={applicationsLink}>{translate('common.buttons.backToApplications')}</Button>
        </InputWrapper>
      </Section>
    </Container>
  );
};
